/*
This file is for handle Zoom / fullscreen button.
Author  : Dipjay Datta<dipjay.d@vcloudx.com>
Company : Vcloudx Infotech
Date	: 07/12/2017 12:05 PM
*/
/* global document */

import Element from './../Element';
import View from './../View';
import DefaultSkin from '../assets/css/defaultCss';

let isDefaultSkin = false;
const Zoomer = (spec) => {
    const that = {};
    isDefaultSkin = spec.skin === 'default';
    if (isDefaultSkin) {
        that.div = Element({
            name: 'i',
            title: 'zoom',
            class: 'fa fa-expand  fa-lg icon_zoom ',
            style: Object.assign(DefaultSkin.icon, DefaultSkin.icon_zoom),
        });
    } else {
        that.div = Element({
            name: 'i',
            title: 'zoom',
            class: `fa fa-expand icon_zoom ${spec.skin}_icon fa-lg ${spec.skin}_icon_zoom`,
        });
    }

    that.div.onclick = function (e) {
        e.stopPropagation();
        Zoomer.click(e, spec);
    };
    return that.div;
};

Zoomer.click = function (e, spec) {
    const skin = spec.skin;
    const player = {
        height: spec.player.height,
        width: spec.player.width,
        position: 'relative',
    };
    const className = e.currentTarget.classList;
    if (className.contains('fa-expand')) {
        e.currentTarget.classList.remove('fa-expand');
        e.currentTarget.classList.add('fa-arrows-alt');
        if (isDefaultSkin) { e.currentTarget.parentNode.parentNode.parentNode.parentNode.setAttribute('style', Element.getStyle(DefaultSkin.full_view)); } else { e.currentTarget.parentNode.parentNode.parentNode.classList.add(`${skin}_theater_view`); }
    } else if (className.contains('fa-arrows-alt')) {
        e.currentTarget.classList.remove('fa-arrows-alt');
        e.currentTarget.classList.add('fa-compress');
        if (isDefaultSkin) {
            e.currentTarget.parentNode.parentNode.parentNode.parentNode.removeAttribute('style');
            e.currentTarget.parentNode.parentNode.parentNode.parentNode.setAttribute('style', Element.getStyle(DefaultSkin.full_view));
        } else {
            e.currentTarget.parentNode.parentNode.parentNode.parentNode.classList.remove(`${skin}_theater_view`);
            e.currentTarget.parentNode.parentNode.parentNode.parentNode.classList.add(`${skin}_full_view`);
        }
    } else if (className.contains('fa-compress')) {
        e.currentTarget.classList.remove('fa-compress');
        e.currentTarget.classList.add('fa-expand');
        if (isDefaultSkin) {
            e.currentTarget.parentNode.parentNode.parentNode.parentNode.removeAttribute('style');
            e.currentTarget.parentNode.parentNode.parentNode.parentNode.setAttribute('style', Element.getStyle(player));
        } else { e.currentTarget.parentNode.parentNode.parentNode.classList.remove(`${skin}_full_view`); }
    }
};

export default Zoomer;



//////////////////
// WEBPACK FOOTER
// ./src/views/component/Zoomer.js
// module id = 182
// module chunks = 0